import { Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { CircleAlert } from 'lucide-react'

export const LogInLinkTooltip = ({ link }: { link: string }) => (
  <Tooltip delayDuration={0}>
    <TooltipTrigger className="max-mobile:text-xs flex items-center gap-2 text-[var(--colorOrange)]">
      <span className="text-inherit transition-colors">
        <Trans>Not Authenticated</Trans>
      </span>
      <CircleAlert size={20} className="h-4 w-4" />
    </TooltipTrigger>
    <TooltipContent sideOffset={8} className="!bg-gray-100 px-3 py-2 !text-base">
      <div className="flex gap-1">
        <a href={link} target="_blank" rel="noreferrer" className="underline hover:opacity-80">
          <Trans>Follow the link</Trans>
        </a>
        {'to log in'}
      </div>
    </TooltipContent>
  </Tooltip>
)
